import { GlobalObject, SubscriptionCriteria } from '../../model/account.model';

export const initialState = {
  viewConfigResponse: null,
  selectedContract: null,
  subcriptionNotAttachedList: [],
  isReady: false,
  loadingData: false,
  loadingView: false,
  NumberVerfied: null,
  notFounddhesionAray: [],
  loadingVerif: false,
  loadingSmsMail: false,
  globalObject: new GlobalObject(),
  loadingCheckMail: false,
};

export type AccountState = Readonly<typeof initialState>;
